// Mirrors the Groups site's catering section: a full-width cream band holding
// a 1400px container, two columns from 1024px, copy centred on phones and
// left-aligned from 640px.
.band {
    background-color: var(--groups-background);
}

.section {
    margin: 0 auto;
    max-width: 1400px;
    padding: 2.5rem 1rem 2rem;

    @media (min-width: 640px) {
        padding: 3rem 1.5rem 2rem;
    }
}

.grid {
    align-items: center;
    display: grid;
    gap: 2.5rem;

    @media (min-width: 1024px) {
        grid-template-columns: 1fr 1fr;
    }
}

.copy {
    text-align: center;

    @media (min-width: 640px) {
        text-align: left;
    }
}

.body {
    margin-top: 1rem;
    max-width: 48rem;
}

.ctaRow {
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;

    @media (min-width: 640px) {
        justify-content: flex-start;
    }
}

.fineprint {
    color: var(--groups-muted-foreground);
    font-size: 0.9375rem;
    margin: 1.5rem 0 0;

    @media (min-width: 640px) {
        font-size: 1rem;
    }
}

.image {
    border-radius: 12px;
    box-shadow: var(--groups-shadow-card);
    display: block;
    height: auto;
    object-fit: cover;
    width: 100%;
}
